import React, { Component } from 'react'
import { connect } from 'react-redux'
import UsersForm from '../../../components/forms/UserForm'

import {
    isAllowed,
    req,
    ADMIN,
    USER,
    REPORTS,
    SNAP_V2,
    CAR_FORM_V1,
    CAR_FORM_V2,
    CAR_FORM_V3
} from '../../../util'

import { toggleLoading, toggleSnackBar } from '../../../redux/actions'

const mapStateToProps = state => ({
    user: state.user
})

const mapDispatchToProps = dispatch => ({
    toggleLoading: () => dispatch(toggleLoading()),
    toggleSnackBar: msg => dispatch(toggleSnackBar(msg))
})

class UsersNew extends Component {
    constructor(props) {
        super(props);
        this.state = {
            user: {
                name: '',
                username: '',
                password: '',
                phone: '',
                status: false,
                roles: [],
                email: "",
            }
        }
    }


    onTextChange = (evt) => this.setState({ user: { ...this.state.user, [evt.target.name]: evt.target.value } })

    handleSelectChange = field => value => this.setState({ [field]: value });

    onCheckChange = (role) => (checked) => {
        let { user } = this.state;
        if (role === 'status') return this.setState({ user: { ...this.state.user, status: checked } })
        let index = user.roles.indexOf(role)
        if (index >= 0) {
            user.roles.splice(index, 1)
        } else {
            user.roles.push(role)
        }
        this.setState({ user })
    }


    createRoles = (roles = []) => ({
        ADMIN: roles.includes(ADMIN),
        USER: roles.includes(USER),
        REPORTS: roles.includes(REPORTS),
        SNAP_V2: roles.includes(SNAP_V2),
        CAR_FORM_V1: roles.includes(CAR_FORM_V1),
        CAR_FORM_V2: roles.includes(CAR_FORM_V2),
        CAR_FORM_V3: roles.includes(CAR_FORM_V3)
    })

    onSubmit = (evt) => {
        let { toggleLoading, toggleSnackBar } = this.props;
        evt.preventDefault()
        let { user } = this.state;
        if (user.status) { user.status = 1 } else { user.status = 0 }
        toggleLoading()
        req('POST', 'auth/users', user).then(res => {
            let { success, msg } = res;
            if (success) {
                this.setState({
                    user: {
                        name: '',
                        username: '',
                        password: '',
                        phone: '',
                        status: false,
                        roles: []
                    }
                })
                toggleLoading();
                toggleSnackBar(`تم اضافة المستخدم ${user.name}`)
            } else {
                toggleLoading();
                toggleSnackBar(msg || "هنالك مشكلة في التطبيق")
            }
        }).catch(e => {
            toggleLoading()
            toggleSnackBar('هنالك مشكلة في الشبكة !')
            console.error(e)
        })
    }


    componentWillMount = () => {
        let { user, history } = this.props;
        if (!user.loggedIn) return history.push('/login')
        if (!isAllowed(user.user, ["USER"])) return history.push('/unauthrized')
    }


    goBack = (e) => {
        e.preventDefault()
        this.props.history.push("/settings/users/edit")
    }

    componentDidMount = () => {
        // this.getBranches()
    }




    render() {
        let { user } = this.state;
        let roles = this.createRoles(user.roles)
        return (
            <UsersForm
                title='أضافة مستخدم جديد'
                onTextChange={this.onTextChange}
                onCheckChange={this.onCheckChange}
                onSubmit={this.onSubmit}
                {...roles}
                {...user}
                goBack={this.goBack}
                update={false}
                handleSelectChange={this.handleSelectChange}
                {...this.state}
            />
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(UsersNew)